import React, { useState } from 'react';
import axios from 'axios';
import { FaUser, FaEnvelope, FaCommentDots } from 'react-icons/fa';
import './ContactForm.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', msg: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: 'loading', msg: 'Sending your message...' });
    try {
      const res = await axios.post('https://ikaze-thouse-backend.vercel.app/api/v1/contact/SendMessage', formData);
      if (res.data.success) {
        setStatus({ type: 'success', msg: 'Thank you! Your message was sent successfully.' });
        setFormData({ name: '', email: '', message: '' });
      } else {
        setStatus({ type: 'error', msg: 'Failed to send message. Please try again.' });
      }
    } catch (err) {
      console.error(err);
      setStatus({ type: 'error', msg: 'Something went wrong. Please check your connection.' });
    }
  };

  return (
    <div className="contact-wrapper">
      <div className="contact-container">
        <div className="contact-header">
          <h2>Get in Touch</h2>
          <p>Have questions about GKM Invest? Drop us a message and our team will get back to you shortly via Email provided .</p>
        </div>
        
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label className="form-label">
              <FaUser className="form-icon" /> Name
            </label>
            <input
              type="text"
              name="name"
              placeholder="Danny"
              value={formData.name}
              onChange={handleChange}
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              <FaEnvelope className="form-icon" /> Email Address
            </label>
            <input
              type="email"
              name="email"
              placeholder="e.g: danny@gmail.com"
              value={formData.email}
              onChange={handleChange}
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              <FaCommentDots className="form-icon" /> Message
            </label>
            <textarea
              name="message"
              placeholder="How can we help you?"
              value={formData.message}
              onChange={handleChange}
              required
              className="form-textarea"
            ></textarea>
          </div>

          <button type="submit" className="form-button" disabled={status.type === 'loading'}>
            {status.type === 'loading' ? 'Sending...' : 'Send Message'}
          </button>

          {status.msg && (
            <div className={`status-message ${status.type}`}>
              {status.msg}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default ContactForm;